export const roleOptions = [
  { value: 'resource_op', label: 'Resource Operator' },
  { value: 'dataset_admin', label: 'Dataset Admin' },
  { value: 'sp_admin', label: 'Sharing Profile Admin' },
  { value: 'user_admin', label: 'User admin' },
];

export const roleOptionsFilter = [
  { value: 'resource_op', text: 'Resource Operator' },
  { value: 'dataset_admin', text: 'Dataset Admin' },
  { value: 'sp_admin', text: 'Sharing Profile Admin' },
  { value: 'user_admin', text: 'User admin' },
];

export const clearanceOptions = [
  { value: '1', label: '1 - Public' },
  { value: '2', label: '2 - Private' },
  { value: '3', label: '3 - Confidential' },
  { value: '4', label: '4 - Secret' },
  { value: '5', label: '5 - Top Secret' },
];

export const colors = ['#62466B', '#976CA4', '#CCA349', '#EECC81', '#4D878C', '#7ECBD2', '#953C3E', '#DFC2C2'];
